import { Header } from '@/utils/datatable/datatableInterface';
import DatatableIntetrface from '@/utils/datatable/datatableInterface'
import Datatable  from '@/utils/datatable/datatable'
const headers:Header[] = [
  {value:'Id', text: 'Id' , isPrice : false , isTotal:false , total:0},
  {value:'Name', text: 'Name' , isPrice : false , isTotal:false , total:0},
  {value:'NameAr', text: 'Arabic Name' , isPrice : false , isTotal:false , total:0},
  {value:'Img', text: 'Image' , isPrice : false , isTotal:false , total:0},
  {value:'CreatedAt', text: 'Created At' , isPrice : false , isTotal:false , total:0},
  {value:'Actions', text: 'Actions' , isPrice : false , isTotal:false , total:0},
]
const url = "brands"

const params:DatatableIntetrface = {
    title : "brands",
    headers ,
    description:"brands_desc",
    searchable:true,
    url,
    hasFooter:false,
    hasEdit:true,
    hasCreate:true
}
const datatable = new Datatable(params)
export default datatable